<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle">table of <i>contents</i></h2>
<p class="tocfm"><a href="#/xhtml/fm02"><b>acknowledgments</b></a></p>
<p class="tocfm"><a href="#/xhtml/fm03"><b>foreword</b> <i>by Dr. Josh Axe</i></a></p>
<p class="tocpart"><a href="#/xhtml/part01"><b>PART ONE: commonsense evidence</b></a></p>
<p class="tocch"><a href="#/xhtml/chap01"><span class="clr">CHAPTER 1:</span> <i>you are not sinking</i></a></p>
<p class="tocch"><a href="#/xhtml/chap02"><span class="clr">CHAPTER 2:</span> <i>you are not your past</i></a></p>
<p class="tocch"><span href="#/xhtml/chap03" title="Link target outside of Sample"><span class="clr">CHAPTER 3:</span> <i>inflammation is the devil</i></span></p>
<p class="tocch"><span href="#/xhtml/chap04" title="Link target outside of Sample"><span class="clr">CHAPTER 4:</span> <i>disease from sea to shining sea</i></span></p>
<p class="tocpart"><span href="#/xhtml/part02" title="Link target outside of Sample"><b>PART TWO: commonsense action</b></span></p>
<p class="tocch"><span href="#/xhtml/chap05" title="Link target outside of Sample"><span class="clr">CHAPTER 5:</span> <i>eat well</i></span></p>
<p class="tocch"><span href="#/xhtml/chap06" title="Link target outside of Sample"><span class="clr">CHAPTER 6:</span> <i>sleep well</i></span></p>
<p class="tocch"><span href="#/xhtml/chap07" title="Link target outside of Sample"><span class="clr">CHAPTER 7:</span> <i>move well</i></span></p>
<p class="tocch"><span href="#/xhtml/chap08" title="Link target outside of Sample"><span class="clr">CHAPTER 8:</span> <i>poop well</i></span></p>
<p class="tocch"><span href="#/xhtml/chap09" title="Link target outside of Sample"><span class="clr">CHAPTER 9:</span> <i>de-stress well</i></span></p>
<p class="tocch"><span href="#/xhtml/chap10" title="Link target outside of Sample"><span class="clr">CHAPTER 10:</span> <i>commune well</i></span></p>
<p class="tocbmt"><span href="#/xhtml/bm01" title="Link target outside of Sample"><b>endnotes</b></span></p>
<p class="tocbm"><span href="#/xhtml/bm02" title="Link target outside of Sample"><b>about the author</b></span></p>
<p class="tocbm"><span href="#/xhtml/bm03" title="Link target outside of Sample"><b>resources</b></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?51dbc592